import { Injectable } from '@angular/core';
import { Base64ToBlobService } from './base64-to-blob.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PrintWebSocketService } from './print-web-socket.service';

@Injectable({
    providedIn: 'root'
  })
export class ImagePrintService {

  contentType = 'image/jpeg';

  constructor(
    private base64ToBlobService: Base64ToBlobService,
    private printWebSocketService: PrintWebSocketService,
    private domSanitizer: DomSanitizer) { }

  base64ToImageUrl(base64: string): string {
    const blob = this.base64ToBlobService.base64toBlob(base64, this.contentType);
    return window.URL.createObjectURL(blob);
  }

  base64ToPdfSafeResourceUrl(base64: string): SafeResourceUrl {
    const blobUrl = this.base64ToImageUrl(base64);
    return this.domSanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }

  base64ToImagePrint(base64: string, printType: string = '', disablePrintServer: boolean = false): void {
    if ( !this.printWebSocketService.isClosed && !disablePrintServer ) {
      this.printWebSocketService.sendPrint(printType, base64); 
    } else { 
      const pdfbUrl = this.base64ToImageUrl(base64); 
      this.imageUrlToImagePrint(pdfbUrl);
    }
  }

  imageUrlToImageSafeResourceUrl(pdfUrl: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  }

   imageUrlToImagePrint(pdfUrl: string)  {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }
}
